import { render, staticRenderFns } from "./data20.vue?vue&type=template&id=a8ee0736&scoped=true"
import script from "./data20.vue?vue&type=script&lang=js"
export * from "./data20.vue?vue&type=script&lang=js"
import style1 from "./data20.vue?vue&type=style&index=1&id=a8ee0736&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ee0736",
  null
  
)

export default component.exports